import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// import React from "react";
// import IconBoxData from '../../data/iconBox/icon-box.json';
// import IconBox from '../../components/IconBox/IconBox.jsx';
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import NewGif from "../../components/Gif/NewGif";

const ServiceIconBox = ({ classOption }) => {
  return (
    <div className={`section section-padding-t50-b80 ${classOption}`}>
      <div className="container">


        <SectionTitle title="Announcement" />
        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul className="li-align">

            <li>
              <h5>
                <div className="font-red">
                  <NewGif />{" "}
                  <strong>The conference venue has been confirmed!</strong> ICSI&apos;2026 will be
                  held at <strong>Jinniu Hotel (金牛宾馆)</strong> in Chengdu, China. On-site
                  registration, technical sessions, meals, and social events will all take place
                  within the hotel complex. Please visit the{" "}
                  <Link to={process.env.PUBLIC_URL + "/venue"} className="font-blue">Venue</Link> and{" "}
                  <Link to={process.env.PUBLIC_URL + "/accommodation"} className="font-blue">Accommodation</Link> pages for details.
                </div>
              </h5>
            </li>

            <li>
              <h5>
                <div className="font-red">
                  <NewGif />{" "}
                  <strong>Public Registration is now open!</strong> ICSI&apos;2026 warmly
                  welcomes scholars and practitioners from around the world — whether
                  or not you have a paper — to join us in Chengdu, China. Listen to
                  keynote speeches and cutting-edge research presentations, participate
                  in tutorials and panel discussions, and share your insights with the
                  global swarm intelligence community. 
                  <br />
                  Registration deadline:{" "}
                  <span style={{ color: "#de162a" }}>July 18th, 2026</span>.
                </div>
              </h5>
            </li>


            <li>
              <h5>
                <div className="font-red">
                  Author registration has been completed. If you are an accepted
                  author and still need assistance, please contact us at{" "}
                  <a href="mailto:icsi2026@iasei.org" className="font-blue">
                    icsi2026@iasei.org
                  </a>{" "}
                  or via WeChat (<span className="font-blue">ICSI_Secretariat</span>).
                </div>
              </h5>
            </li>

            <li>
              <h5>
                <div className="font-red">
                  Selected excellent papers from the conference will be recommended for publication in a Special Issue of the prestigious <span style={{ color: "#de162a" }}>International Journal of Information Technology &amp; Decision Making (IJITDM)</span>.
                </div>
              </h5>
            </li>

            <div
              className="text-center mb-4"
              style={{ transform: "translate(-88px, 20px)" }}
            >
              <Link className="btn btn-primary btn-hover-secondary mt-s" to={process.env.PUBLIC_URL + "/registration_pub"}>
                Public Registration
              </Link>
            </div>

            {/* <li>
              <h5>
                <div className="font-red" >
                  <NewGif />{" "}
                  ICSI&apos;2026 call for papers!
                </div>
              </h5>
            </li> */}

            {/* <li>
              <h5>
                <div >
                  <a href="./specialsession#session5">
                  {" "}
                    Special Session 5: &quot;Biologically Inspired Intelligence for Mechatronics and Robotics&quot;{" "}
                  </a>
                </div>
              </h5>
            </li> */}
         
            {/* <li>
                <h5>
                <div >
                <a href="./specialsession">
                {" "}
                <del>
                ICSI&apos;2024 Call for Special Session Proposals!
                </del>
                </a>
                </div>
                </h5>
              </li>
            <li>
              <h5>
                <div  >

                    {" "}
                    <del>
                    ICSI&apos;2024 Call for Papers!
                    </del>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                    {" "}
                    <del>
                    Author registration is open, please complete the author registration before May 31!
                    </del>
                </div>
              </h5>
            </li>

            <li>
              <h5>
                <div>
                  <a href="./accommodation">
                    <del>
                    As this period coincides with the local peak tourist season, hotel rooms are in short supply, and prices are high during the peak season. To facilitate the efficient and economical participation of delegates for ICSI’2024, our organizing committee has negotiated with the Qinghai Hotel to reserve some rooms for online booking by delegates. The prices are very favorable. Please complete the online booking before July 21st. Otherwise, we cannot guarantee rooms at this contracted price.
                    </del>
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./accommodation">
                  <del>
                    ICSI’2024将于2024年8月23-26日在青海西宁市的青海宾馆隆重举行。鉴于此时正值当地旅游旺季，各宾馆房间供不应求且价格较高。为了方便各位代表能高效且经济参会，会务组与宾馆经过协商预订了一些房间，供各位参会代表在线预订，价格非常实惠。请大家必须在7月21日之前完成在线预订，逾期预订将无法保证房间及优惠价格。
                  </del>
                  </a>
                </div>
              </h5>
            </li> */}




            {/* <li>
              <h5>
              <div className="font-red" >
              <a href="./gallery">
              <NewGif />{" "}
              Congratulations! ICSI&apos;2023 has been held successfully on 14th - 18th, July! 
              </a>
              </div>
              </h5>
              </li>
            <li>
              <h5>
                <div className="font-red" >
                  <a href="./gallery">
                    <NewGif />{" "}
                    Our wonderful moments!
                  </a>
                </div>
              </h5>
            </li> */}




          </ul>
        </div>


        <div className="space-100"></div>


        {/* <div>
        Notice: 
        Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
        </div> */}
        <div className="conference-ind">

          {/* <div className="online-info" >
 Notice: 
Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
</div> */}
        </div>
      </div>
    </div >
  );
};

ServiceIconBox.propTypes = {
  classOption: PropTypes.string,
};
ServiceIconBox.defaultProps = {
  classOption: "section section-padding-t90-b100",
};

export default ServiceIconBox;
